import './preload.scss';

const destroyLoader = () => {
    const preloaderNode = document.querySelector('.preloader');

    preloaderNode.classList.add('hide');

    setTimeout(() => {
        preloaderNode.remove();
    }, 1000);
};

const loadImage = async (src = '') => new Promise((resolve) => {
    const img = new Image();

    img.src = src;
    img.onload = () => {
        resolve();
    };
    img.onerror = () => {
        resolve();
    };
});

const initLoading = () => {
    const srcArr = [...document.querySelectorAll('img:not([loading="lazy"])')].map((el) => el.src);
    const promiseArr = srcArr.map((src) => loadImage(src));

    Promise.all(promiseArr).then(() => destroyLoader());
};

initLoading();
